import { css } from 'lit';
export const spinnerStyles = css `
    :host {
        display: inline-flex;
        width: 1em;
        height: 1em;
    }

    .hlx-spinner {
        flex: 1 1 auto;
        height: 100%;
        width: 100%;
    }

    .hlx-spinner-track,
    .hlx-spinner-indicator {
        fill: none;
        stroke-width: 2px;
        r: calc(0.5em - 2px / 2);
        cx: 0.5em;
        cy: 0.5em;
        transform-origin: 50% 50%;
    }

    .hlx-spinner-track {
        stroke: rgb(128 128 128 / 25%);
        transform-origin: 0% 0%;
    }

    .hlx-spinner-indicator {
        stroke: currentColor;
        stroke-linecap: round;
        stroke-dasharray: 150% 75%;
        animation: spin 2s linear infinite;
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
            stroke-dasharray: 0.01em, 2.75em;
        }

        50% {
            transform: rotate(450deg);
            stroke-dasharray: 1.375em, 1.375em;
        }

        100% {
            transform: rotate(1080deg);
            stroke-dasharray: 0.01em, 2.75em;
        }
    }
`;
//# sourceMappingURL=spinner.styles.js.map